<div class="main-view space-y-2 md:space-y-4">
    <app-page-surface-header
        titleIcon="billing"
        title="Record Payment"
        [subtitle]="businessName ? 'Invoice for ' + businessName : 'Invoice payment'"
    />

<div class="panel mb-5">
    <h6 class="mb-3 font-semibold">Invoice Details</h6>
    <div class="grid gap-3 sm:grid-cols-2">
        <div class="flex justify-between"><span>Basic Amount</span><span class="font-semibold">{{ basicAmount | number: '1.2-2' }}</span></div>
        <div class="flex justify-between"><span>CGST</span><span class="font-semibold">{{ cgst | number: '1.2-2' }}</span></div>
        <div class="flex justify-between"><span>SGST</span><span class="font-semibold">{{ sgst | number: '1.2-2' }}</span></div>
        <div class="flex justify-between"><span>Total Invoice</span><span class="font-semibold">{{ totalInvoice | number: '1.2-2' }}</span></div>
        <div class="flex justify-between"><span>Received Amount</span><span class="font-semibold">{{ receivedAmount | number: '1.2-2' }}</span></div>
        <div class="flex justify-between"><span>Remaining Amount</span><span class="font-semibold">{{ remainingAmount | number: '1.2-2' }}</span></div>
    </div>
</div>

<div class="panel">
    <div class="grid gap-4 sm:grid-cols-3">
        <div>
            <label for="business-name" class="mb-1.5 block text-sm font-medium">Business Name</label>
            <input id="business-name" type="text" class="form-input" [value]="businessName" disabled />
        </div>
        <div>
            <label for="invoice-number" class="mb-1.5 block text-sm font-medium">Invoice Number</label>
            <input id="invoice-number" type="text" class="form-input" [value]="invoiceNumber" disabled />
        </div>
        <div>
            <label for="payment-date" class="mb-1.5 block text-sm font-medium">Payment Date <span class="text-danger">*</span></label>
            <input id="payment-date" type="date" class="form-input" [(ngModel)]="paymentDate" name="paymentDate" />
        </div>

        <div>
            <label for="reference" class="mb-1.5 block text-sm font-medium">Transaction Reference Number <span class="text-danger">*</span></label>
            <input id="reference" type="text" class="form-input" placeholder="Enter Transaction Reference Number"
                [(ngModel)]="reference" name="reference" />
        </div>
        <div>
            <label for="holder" class="mb-1.5 block text-sm font-medium">Account Holder Name <span class="text-danger">*</span></label>
            <input id="holder" type="text" class="form-input" placeholder="Enter Account Holder Name"
                [(ngModel)]="accountHolderName" name="accountHolderName" />
        </div>
        <div>
            <label for="account" class="mb-1.5 block text-sm font-medium">Account Number <span class="text-danger">*</span></label>
            <input
                id="account"
                type="text"
                inputmode="numeric"
                autocomplete="off"
                maxlength="18"
                class="form-input"
                placeholder="Enter Account Number"
                [class.border-danger]="accountNumberError"
                [ngModel]="accountNumber"
                (ngModelChange)="onAccountNumberChange($event)"
                (blur)="onAccountNumberBlur()"
                name="accountNumber"
            />
            <p *ngIf="accountNumberError" class="mt-1 text-xs text-danger">{{ accountNumberError }}</p>
        </div>

        <div>
            <label for="paid-amount" class="mb-1.5 block text-sm font-medium">Paid Amount <span class="text-danger">*</span></label>
            <input
                id="paid-amount"
                type="number"
                step="0.01"
                min="0"
                class="form-input"
                placeholder="Enter Paid Amount"
                [class.border-danger]="paidAmountError"
                [ngModel]="paidAmount"
                (ngModelChange)="onPaidAmountChange($event)"
                (blur)="onPaidAmountBlur()"
                name="paidAmount"
            />
            <p *ngIf="paidAmountError" class="mt-1 text-xs text-danger">{{ paidAmountError }}</p>
        </div>

        <div>
            <span class="mb-1.5 block text-sm font-medium">Tax Deducted ? <span class="text-danger">*</span></span>
            <label class="mr-4 inline-flex items-center">
                <input type="radio" name="taxDeducted" [checked]="!taxDeducted"
                    [disabled]="tdsAlreadyRecorded || tdsHistoryLoadError" (change)="onTaxDeductedChange(false)" />
                <span class="ml-2">No, Tax Deducted</span>
            </label>
            <label class="inline-flex items-center">
                <input type="radio" name="taxDeducted" [checked]="taxDeducted"
                    [disabled]="tdsAlreadyRecorded || tdsHistoryLoadError" (change)="onTaxDeductedChange(true)" />
                <span class="ml-2">Yes, Tax Deducted</span>
            </label>
            <p *ngIf="tdsAlreadyRecorded" class="mt-1 text-xs text-gray-500">
                TDS has already been recorded for this invoice.
            </p>
            <p *ngIf="tdsHistoryLoadError" class="mt-1 text-xs text-danger">
                Could not load payment history, so TDS cannot be recorded right now. You can still record the payment without TDS.
            </p>
        </div>

        <div *ngIf="taxDeducted">
            <label for="tds-section" class="mb-1.5 block text-sm font-medium">TDS Section <span class="text-danger">*</span></label>
            <select id="tds-section" class="form-select" [(ngModel)]="tdsSection" name="tdsSection" (ngModelChange)="onTdsSectionChange()">
                <option value="" disabled>Select TDS Section</option>
                <option *ngFor="let s of tdsSections" [value]="s.value">{{ s.label }}</option>
            </select>
        </div>

        <div *ngIf="taxDeducted">
            <label for="tds-amount" class="mb-1.5 block text-sm font-medium">TDS Amount</label>
            <input id="tds-amount" type="text" class="form-input"
                placeholder="Calculated from TDS section" [value]="tdsAmount | number: '1.2-2'" disabled />
        </div>

        <div>
            <label for="total-recorded" class="mb-1.5 block text-sm font-medium">Total Payment Recorded</label>
            <input
                id="total-recorded"
                type="text"
                class="form-input"
                [class.border-danger]="exceedsRemainingAmount"
                [value]="totalPaymentRecorded | number: '1.2-2'"
                disabled
            />
            <p *ngIf="exceedsRemainingAmount && tdsAmount > 0" class="mt-1 text-xs text-danger">
                Including TDS, total exceeds the remaining amount of {{ remainingAmount | number: '1.2-2' }}.
            </p>
        </div>
    </div>

    <p *ngIf="invoiceLoadError" class="mt-4 text-sm text-danger">
        Could not load this invoice, so payment cannot be recorded right now. Please refresh the page.
    </p>
    <p *ngIf="submitError" class="mt-4 text-sm text-danger">{{ submitError }}</p>

    <div class="mt-6 flex justify-end gap-3">
        <button
            type="button"
            class="btn rounded-full border border-gray-300 bg-white px-6 py-2 text-sm font-medium text-black hover:bg-gray-50 dark:border-[#191e3a] dark:bg-[#0e1726] dark:text-white dark:hover:bg-white/5"
            (click)="cancel()"
        >
            Cancel
        </button>
        <button
            type="button"
            class="btn rounded-full bg-[#303030] px-8 font-semibold text-white shadow-lg disabled:cursor-not-allowed disabled:opacity-60"
            [disabled]="!canSubmit"
            (click)="submit()"
        >
            {{ submitting ? 'Recording…' : 'Record Payment' }}
        </button>
    </div>
</div>
</div>
